/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SnackBarAlertContext } from "../../../contexts/SnackbarContext";
import { SidebarContext } from "../../../contexts/SidebarContext";
import request from "../../../request";

const useQuery = (
  endPoint: string,
  variables?: any,
  reDirectTo?: string | null,
  enabled: boolean = true,
) => {
  const navigate = useNavigate();
  const snackBarAlertContext = useContext(SnackBarAlertContext);
  const { payload, setPayload } = useContext(SidebarContext);

  const [initialMount, setInitialMount] = useState<boolean>(true);
  const [response, setResponse] = useState<{
    loading: boolean;
    error: any;
    data: any;
  }>({
    loading: true,
    error: null,
    data: null,
  });
  const fetchData = async () => {
    if (!enabled) return;
    if (initialMount) {
      if (
        payload.search ||
        payload.skip !== 0 ||
        payload.take !== 25 ||
        payload.sortBy !== null ||
        payload.sortOrder !== null ||
        (payload?.filter?.default ?? null) !== null
      ) {
        // Reset payload on initial mount
        setInitialMount(false);
        setPayload((prevData: any) => {
          return {
            ...prevData,
            skip: 0,
            take: 25,
            sortOrder: null,
            sortBy: null,
            search: "",
            filter: { ...prevData?.filter, default: null },
          };
        });
        return;
      } else setInitialMount(false);
    }
    try {
      setResponse({
        loading: true,
        data: null,
        error: null,
      });
      let apiResponse = await request.get(endPoint, variables);
      if (response) {
        setResponse({
          loading: false,
          data: apiResponse?.data,
          error: null,
        });
      }
    } catch (error: any) {
      setResponse({ loading: false, data: null, error: error });
      if (reDirectTo) {
        navigate(reDirectTo);
      }
      snackBarAlertContext.set({
        status: true,
        type: "error",
        message: error.message,
      });
    }
  };
  const variablesKey = JSON.stringify(variables);

  useEffect(() => {
    if (!enabled) return;
    fetchData();
  }, [
    endPoint,
    variablesKey,
    payload?.search,
    payload?.skip,
    payload?.take,
    payload?.sortBy,
    payload?.sortOrder,
    payload?.filter,
    enabled,
  ]);

  return { ...response, fetchData };
};

export default useQuery;
